import { takeEvery, select, put } from 'redux-saga/effects';
import qs from 'qs';
import { replace } from 'connected-react-router';
import errorhandler from 'errorHandler';

import { stores as storesActions, router as routerActions } from 'flux/actions';
import { stores as storesSelectors, router as routerSelectors, flyers as flyersSelectors } from 'flux/selectors';

export function* onRouterQueryUpdated({ payload: { query } }) {
  const { sf_store_id: sfStoreId, storeId, retailerId, ...filteredQuery } = query ?? {};
  const chosenStoreId = storeId ?? sfStoreId;
  let chosenRetailerId = retailerId;

  if (!retailerId && chosenStoreId) {
    const retailer = yield select(flyersSelectors.selectRetailerFromFirst);
    chosenRetailerId = retailer?.id;
  }
  if (chosenRetailerId && chosenStoreId) {
    const extId = `${chosenRetailerId}_${btoa(chosenStoreId)}`;
    const routerCurrentStoreId = yield select(storesSelectors.selectStoreIdByCustomerCodeOrExtId, chosenStoreId, extId);
    const currentStoreId = yield select(storesSelectors.selectCurrentStoreId);

    if (currentStoreId !== routerCurrentStoreId) {
      yield put(storesActions.setCurrentStore(routerCurrentStoreId));
    }

    try {
      if (!routerCurrentStoreId) {
        throw Error(`No store was found with id="${chosenStoreId}".`);
      }

      if (currentStoreId !== routerCurrentStoreId) {
        yield put(storesActions.setCurrentStore(routerCurrentStoreId));
      }
    } catch (error) {
      const { pathname } = yield select(routerSelectors.selectRouterLocation);
      const filteredSearch = qs.stringify(filteredQuery);
      const search = filteredSearch ? `?${filteredSearch}` : '';
      // remove invalid Qs from url
      yield put(replace(`${pathname}${search}`));
      errorhandler(error, true);
    }
  }
}

export default function* () {
  yield takeEvery(routerActions.types.UPDATE_QUERY, onRouterQueryUpdated);
}
